import {Drawer} from './Drawer';
import {shakeUnsaved} from './Form/UnsavedShake';
import {FormDirtyTracker} from '../Library/FormDirtyTracker';
import {cloneSpinner} from '../Library/LoadingIndicator';

const findSubmitButton = (dialog, form) => {
    return dialog.querySelector(`button[type="submit"][form="${form.id}"]`)
        ?? form.querySelector('button[type="submit"]');
};

export const openFormModal = (dialog) => {
    const dirtyTracker = FormDirtyTracker(dialog);

    const isCloseable = () => !dirtyTracker.isDirty();

    const shakeFooter = () => {
        const footer = dialog.querySelector('footer');

        if (!footer) {
            return;
        }

        shakeUnsaved(footer);
    };

    const handleKeydown = (event) => {
        if (event.key !== 'Escape') {
            return;
        }

        if (isCloseable()) {
            drawer.close();

            return;
        }

        shakeFooter();
    };

    let armingXhr = null;

    const handleBeforeRequest = (event) => {
        const submitButton = findSubmitButton(dialog, event.target);

        if (!submitButton) {
            return;
        }

        armingXhr = event.detail.xhr;
        submitButton.dataset.idleHtml ??= submitButton.innerHTML;
        submitButton.disabled = true;
        submitButton.replaceChildren(cloneSpinner(), ` ${dialog.dataset.processingText}`);
    };

    const handleAfterRequest = (event) => {
        if (armingXhr === null || event.detail.xhr !== armingXhr) {
            return;
        }

        armingXhr = null;

        for (const submitButton of dialog.querySelectorAll('button[type="submit"][data-idle-html]')) {
            submitButton.disabled = false;
            submitButton.innerHTML = submitButton.dataset.idleHtml;
            delete submitButton.dataset.idleHtml;
        }
    };

    const onClose = () => {
        dirtyTracker.destroy();
        document.removeEventListener('keydown', handleKeydown);
        dialog.removeEventListener('htmx:beforeRequest', handleBeforeRequest);
        dialog.removeEventListener('htmx:afterRequest', handleAfterRequest);

        dialog.remove();
    };

    const drawer = Drawer(dialog, {
        onClose: onClose,
        closeOutside: true,
        animateMask: false,
        closeEvent: 'closemodal',
        maskExcludedSelector: '.form-modal',
        beforeClose: isCloseable,
        onCloseBlocked: shakeFooter,
    });

    document.querySelector('.mask')?.click();

    document.addEventListener('keydown', handleKeydown);
    dialog.addEventListener('htmx:beforeRequest', handleBeforeRequest);
    dialog.addEventListener('htmx:afterRequest', handleAfterRequest);

    drawer.open();
};
